














import { Component, Model, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class MpLoginInput extends Vue {
  @Prop({ required: true, default: '' })
  placeholder!: string;

  @Prop({ required: false, default: 'text' })
  type!: string;

  @Prop({ required: false, default: undefined })
  prependIcon!: string;

  @Prop({ required: false, default: undefined })
  appendIcon!: string;

  @Prop({ required: false, default: '' })
  value!: string;

  internalValue: string = '';

  @Watch('value')
  onValueChanged() {
    this.internalValue = this.value;
  }

  @Watch('internalValue')
  onInternalValueChanged() {
    this.$emit('input', this.internalValue);
  }
}
